import { ReactNode } from 'react'
import { Paper, Stack } from '@mui/material'

type DatedRightGroupProps = {
  grouped: boolean
  children: ReactNode
}

export const DATED_RIGHT_GROUP_TEST_ID = 'dated-right-group'

// ENG2-2633 — a right that carries date inputs (Global Data with its two
// contract dates, Risika for AI with its end date) shows the toggle and the
// dates as one unit: while the toggle is on and the dates are visible, the
// whole stack sits in an outlined Paper. Off, the toggle renders like every
// other add-on so the grid stays even.
function DatedRightGroup({ grouped, children }: DatedRightGroupProps) {
  const stack = <Stack spacing={1}>{children}</Stack>
  if (!grouped) return stack

  return (
    <Paper
      variant="outlined"
      data-testid={DATED_RIGHT_GROUP_TEST_ID}
      sx={{ p: 1.5, borderRadius: 2 }}
    >
      {stack}
    </Paper>
  )
}

export default DatedRightGroup
